<template>
    <div class="get-today-list-tabs">
        <button
            class="get-today-list-tabs__tab"
            type="button"
            :class="{ 'get-today-list-tabs__tab_active': activeTab == 1 }"
            @click="$emit('changeActiveTab', 1)"
        >
            <span>
                {{ messages.list }}
            </span>
        </button>
        <button
            class="get-today-list-tabs__tab"
            type="button"
            :class="{ 'get-today-list-tabs__tab_active': activeTab == 2 }"
            @click="$emit('changeActiveTab', 2)"
        >
            <span>
                {{ messages.onMap }}
            </span>
        </button>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
// import { useStore } from 'vuex';
// const { state } = useStore();

const { activeTab, messages } = defineProps(['activeTab', 'messages']);


</script>

<script>
export default {
    name: 'GetTodayListTabs',
}
</script>

<style lang="scss" scoped>
.get-today-list-tabs{
    border-bottom: 1px solid var(--border-grey);
    margin-bottom: 16px;
    &__tab{
        padding-bottom: 16px;
        background-color: transparent;
        font-weight: 600;
        font-size: rem(12);
        line-height: 100%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--color-dark-grey);
        border-bottom: 1px solid transparent;
        transform: translateY(1px);
        transition: .2s linear color, .2s linear border-bottom-color;
        width: 50%;
        @include point-md{
            width: unset;
        }
        &:not(:last-child){
            @include point-md{
                margin-right: 40px;
            }
        }
        &_active{
            color: var(--color-main);
            border-bottom-color: var(--background-black);
        }
    }
}
</style>